import { CompanyHomeThemeModeConfig } from './types';

const dark: CompanyHomeThemeModeConfig = {
  companyHome: {},
};

export default dark;
